<template>
    <div></div>
</template>

<script>
    // import Repository from '../../repositories/subscription';
    export default {
        name: "PaymentEvent",
        mounted() {
            this.init();
        },
        methods: {
            init() {
                let eventType = this.$route.query.event;
                if(eventType === 'success') {
                    // this.$route.query.session_id;
                     this.$router.push({
                                name: 'confirmation',
                                params: { titleMessage: this.$t('success.titleMessage'),
                                    bodyMessage: this.$t('success.bodyMessage'),
                                    goToMessage: this.$t('success.goToMessage'),
                                    afterConfirmationRoute: 'dashboard'}
                            });
                    // let sessionId = this.$route.query.session_id;
                    // Repository.successfulResponseFromCheckout(sessionId).then((response) => {
                    //     if(response.status < 400 && response.data) {
                    //         this.$router.push({
                    //             name: 'confirmation',
                    //             params: { titleMessage: this.$t('success.titleMessage'),
                    //                 bodyMessage: this.$t('success.bodyMessage'),
                    //                 goToMessage: this.$t('success.goToMessage'),
                    //                 afterConfirmationRoute: 'dashboard'}
                    //         });
                    //     }
                    // });
                }
                else {
                    this.$router.push({
                        name: 'confirmation',
                        params: { titleMessage: this.$t('failure.titleMessage'),
                            bodyMessage: this.$t('failure.bodyMessage'),
                            goToMessage: this.$t('failure.goToMessage'),
                            afterConfirmationRoute: 'subscription-plans'}
                    });
                }
            },
        }
    }
</script>

<style scoped>

</style>


<i18n>
{
    "en":{
        "success":{
            "titleMessage": "Payment created",
            "bodyMessage": "Once Stripe validates if the transaction was successful, you will get all the benefits of Pro Plan.",
            "goToMessage": "Go to Dashboard"
        },
        "failure":{
            "titleMessage": "Payment canceled",
            "bodyMessage": "You turn back from the checkout page.",
            "goToMessage": "Go to Subscription plans"
        }
    },
    "es":{
        "success":{
            "titleMessage": "Pago creado",
            "bodyMessage": "Una vez Stripe confirme la transacción, obtendrás todos los beneficios del plan Pro.",
            "goToMessage": "Ir al dashboard"
        },
        "failure":{
            "titleMessage": "Pago cancelado",
            "bodyMessage": "Te devuelves de la pagina de pago.",
            "goToMessage": "Ir a los planes de suscripción"
        }
    }
}
</i18n>